<template>
  <el-dialog title="提示" :visible.sync="dialogInfo.show" width="30%">
    <el-form
      :inline="true"
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      size="small"
    >
      <el-form-item label="上线时间：" prop="onlineDate">
        <el-date-picker
          v-model="ruleForm.onlineDate"
          type="datetime"
          placeholder="选择上线时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close(false)">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setOnlineDate } from "@/api/videoSet.js";
export default {
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return { show: false };
      },
    },
    videoSetUuids: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      ruleForm: {
        onlineDate: null,
      },
      rules: {
        onlineDate: [
          { required: true, message: "请选择上线时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    confirm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          setOnlineDate({
            videoSetUuids: this.videoSetUuids,
            onlineDate: this.ruleForm.onlineDate,
          }).then(({ code, msg }) => {
            if (code !== 0) return;
            this.$message.success(msg);
            this.close(true);
          });
        }
      });
    },
    close(flag = false) {
      this.$emit("close", flag);
    },
  },
};
</script>

<style>
</style>